export default __webpack_public_path__ + "static/outcome-bbcb32c63bd252b288bee8682711146d.jpg";